export interface MonthItem {
  code: string;
  description: string;
}

export const MONTH_LIST: MonthItem[] = [
  { code: 'MM01', description: 'January' },
  { code: 'MM02', description: 'February' },
  { code: 'MM03', description: 'March' },
  { code: 'MM04', description: 'April' },
  { code: 'MM05', description: 'May' },
  { code: 'MM06', description: 'June' },
  { code: 'MM07', description: 'July' },
  { code: 'MM08', description: 'August' },
  { code: 'MM09', description: 'September' },
  { code: 'MM10', description: 'October' },
  { code: 'MM11', description: 'November' },
  { code: 'MM12', description: 'December' }
];